var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.997037,0.99234544 A 10.993535,11.007282 0 1 0 22.990572,11.999626 11.005998,11.01976 0 0 0 11.997037,0.99234544 Z m 0,20.32113356 a 9.302222,9.3138535 0 1 1 9.302221,-9.313853 9.3127469,9.3243922 0 0 1 -9.302221,9.313853 z m 7.610909,-9.313853 a 7.6109086,7.6204257 0 1 1 -7.610909,-7.6204246 7.6194964,7.6290241 0 0 1 7.610909,7.6204246 z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.76b5ad0ac12f3f7da35dd7e5888b23df.svg";
export { ForwardRef as ReactComponent };